module.exports = __webpack_public_path__ + "768d92d3b547ab12dad10f69388d6703.pdf";